export const gradient = {
  50: "#7d68f4", // same as purple.700 & primary
  100: "#9B8BF9", // same as purple.600
  150: "#b1a5f9", // same as purple.400
  200: "#edeaff", // close to purple.100
  250: "#eaffff", // cyan bright
  300: "#a5e2f9",
  350: "#68d4f4",
  400: "#68bff4", // cyan deep
  450: "#68f4ad", // green bright
  500: "#a5f9ce",
  550: "#d7ffe8", // green deep
  600: "#ffeafa", // crimson bright
  650: "#f9a5d9",
  700: "#f468af", // crimson deep
  750: "#433881", // same as purple.800 (repeat the chain)
};
